import React from "react";
import { connect } from "react-redux";
import { getSelectedSpeakerEmailAddress } from "../selectors";
import { actions, getters } from "../model";

const decorate = connect(
  state => ({
    selectedSpeakerEmailAddress: getSelectedSpeakerEmailAddress(state),
    isClosed: getters.isClosed(state),
    isViewOnly: getters.isViewOnly(state)
  }),
  {
    clearExternalSpeaker: actions.clearExternalSpeaker
  }
);

const InfoPanel = ({ children, style = {} }) => (
  <div
    style={{
      background: "#E8F7FF",
      border: "1px solid #CCEDFF",
      borderRadius: "4px",
      padding: "16px",
      fontSize: "15px",
      color: "#343434",
      margin: "16px 0 16px 0",
      ...style
    }}
  >
    {children}
  </div>
);

const UndecoratedRegisteredSpeakerInfoPanel = ({
  selectedSpeakerEmailAddress,
  selectedSpeakerId,
  clearExternalSpeaker,
  isClosed,
  isViewOnly
}) => {
  return (
    <InfoPanel
      style={{
        marginTop: "4px"
      }}
    >
      <b>{selectedSpeakerEmailAddress}</b> will be added as a session
      participant. We will send them an email to complete their profile for this
      submission.{" "}
      {!isClosed && !isViewOnly && (
        <span
          onClick={() => clearExternalSpeaker(selectedSpeakerId)}
          style={{
            textDecoration: "underline",
            fontWeight: "600",
            cursor: "pointer"
          }}
        >
          Remove contact
        </span>
      )}
    </InfoPanel>
  );
};

const RegisteredSpeakerInfoPanel = decorate(
  UndecoratedRegisteredSpeakerInfoPanel
);

const FieldsInfoPanel = () => {
  return (
    <InfoPanel>
      <b>These following fields are masked for privacy reasons.</b> They can be
      updated by the speaker once they log into to complete their profile for
      this submission.
    </InfoPanel>
  );
};

export { InfoPanel, FieldsInfoPanel, RegisteredSpeakerInfoPanel };
